import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Blue } from '../../themes/blue/colorPalette';
import { styled } from '@mui/material/styles';

const VLCheckboxGroupContainer = styled(FormControl)(({ theme }) => ({
    '& .MuiFormLabel-root': {
        fontSize: '13px',
        color: theme.palette.grey[4]
    },
    '& .MuiFormGroup-root': {
        padding: 8,
        paddingBottom: 0,
        '& .MuiFormControlLabel-label': {
            fontSize: '15px',
            fontWeight: '500',
            color: Blue[1],
            letterSpacing: '0.24px',
            paddingLeft: 8
        },
        '& .MuiButtonBase-root': {
            padding: 3
        },
        '& .MuiSvgIcon-root': {
            fill: Blue[1],
            height: 24,
            width: 24
        }
    }
}));

const CheckboxGroup = ({ label, selected, options, hideSelectAllCheckbox, onChange }) => {
    const allValues = options.map(opt => opt.value);
    const allOptionsAreSelected = selected.length === allValues.length;
    const isSelectAllCheckboxHidden = hideSelectAllCheckbox ?? false;

    const handleChange = (event) => {
        const value = event.currentTarget.name;

        if (selected.includes(value)) {
            onChange(selected.filter(i => i !== value));
        } else {
            onChange([...selected, value]);
        }
    };

    const handleAllChange = () => {
        if (allOptionsAreSelected) {
            onChange([]);
        } else {
            onChange(allValues);
        }
    };

    const optionCheckboxes = options.map(opt => (
        <div key={`checkbox-group-option-${opt.value}`}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={selected.includes(opt.value)}
                        onChange={handleChange} name={opt.value}
                        icon={<CheckBoxOutlineBlankIcon />}
                        checkedIcon={<CheckBoxIcon />}
                    />
                }
                label={opt.label}
            />
        </div>
    ));

    return (
        <React.Fragment>
            <VLCheckboxGroupContainer component="fieldset">
                <FormLabel component="legend">{ label }</FormLabel>
                <FormGroup>
                    { !isSelectAllCheckboxHidden &&
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="secondary"
                                    checked={allOptionsAreSelected}
                                    onChange={handleAllChange}
                                    name="all"
                                />
                            }
                            label="All"
                        />
                    }

                    { optionCheckboxes }
                </FormGroup>
            </VLCheckboxGroupContainer>
        </React.Fragment>
    );
};

CheckboxGroup.propTypes = {
    hideSelectAllCheckbox: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    selected: PropTypes.array
};

export default CheckboxGroup;
